import { gql } from '@urql/core';

import type { InputCmsPackage, ResultCmsPackage } from '@types/cms';
import type { Client, RequestPolicy, OperationResult } from '@urql/core';

const GET_PACKAGE = gql`
  query CmsPackage($id: ID!) {
    cmsPackage(id: $id) {
      id
      name
      pages {
        id
        name
        url
        cms_package_id
        elements {
          id
          cms_page_id
          element
          name
          type
          contents {
            id
            content
            cms_language_id
            cms_element_id
          }
        }
      }
    }
  }
`;

export const fetchCmsPackage = async (
  client: Client,
  input: InputCmsPackage,
  fetchOptions?: RequestInit,
  requestPolicy?: RequestPolicy,
): Promise<ResultCmsPackage> => {
  const result = await gqlQuery(
    client,
    GET_PACKAGE,
    input,
    () => {},
    fetchOptions,
    requestPolicy,
  );

  validateCmsPackage(result);
  return result;
};

function validateCmsPackage(
  cmsPackage: OperationResult<ResultCmsPackage, InputCmsPackage>['data'],
): asserts cmsPackage is ResultCmsPackage {
  if (!cmsPackage) throw new Error('ERR:: fetchCmsPackage: not data available');
}
